export default "__VITE_ASSET__CjO6aROz__"